import apiClient from './client'
import API from '@/api/API'
import { Model, CreateModelRequest, ModelDefaults, ProviderAvailability, ProviderSettings, ProviderSettingsUpdate, FishownapiSyncKeyResult } from '@/lib/types/models'

export const modelsApi = {
  list: async () => {
    const response = await apiClient.get<Model[]>(API.models.base)
    return response.data
  },

  get: async (id: string) => {
    const response = await apiClient.get<Model>(`${API.models.base}/${id}`)
    return response.data
  },

  create: async (data: CreateModelRequest) => {
    const response = await apiClient.post<Model>(API.models.base, data)
    return response.data
  },

  delete: async (id: string) => {
    await apiClient.delete(`${API.models.base}/${id}`)
  },

  getDefaults: async () => {
    const response = await apiClient.get<ModelDefaults>(API.models.defaults)
    return response.data
  },

  updateDefaults: async (data: Partial<ModelDefaults>) => {
    const response = await apiClient.put<ModelDefaults>(API.models.defaults, data)
    return response.data
  },

  getProviders: async () => {
    const response = await apiClient.get<ProviderAvailability>(API.models.providers)
    return response.data
  },

  getProviderSettings: async () => {
    const response = await apiClient.get<ProviderSettings>(API.models.providerSettings)
    return response.data
  },

  updateProviderSettings: async (data: ProviderSettingsUpdate) => {
    const response = await apiClient.put<ProviderSettings>(API.models.providerSettings, data)
    return response.data
  },

  syncFishownapiKey: async () => {
    const response = await apiClient.post<FishownapiSyncKeyResult>(API.models.syncFishownapiKey)
    return response.data
  },
}
